import React from 'react';
import { FiMap } from "react-icons/fi";
import MessageIcon from '../messageSection/MessageIcon';
import './LocationBlock.css';

function LocationBlock({ title, city, venue, time, mapUrl, icon, mapButtonText = "See on the map" }) {
  return (
    <div className="location-block">
      {icon && (
        <div className="location-icon">
          <MessageIcon icon={icon} />
        </div>
      )}
      
      {title && (
        <h2 className="location-title">{title}</h2>
      )}
      
      {city && (
        <p className="location-text">{city}</p>
      )}
      
      {venue && (
        <p 
          className="location-text"
          dangerouslySetInnerHTML={{ __html: venue.replace(/\n/g, '<br />') }}
        />
      )}
      
      {time && (
        <p className="location-time">{time}</p>
      )}
      
      {mapUrl && (
        <div className="map-button-wrapper">
          <a 
            href={mapUrl}
            target="_blank" 
            rel="noopener noreferrer"
            className="map-button"
          >
            <FiMap className="map-icon" />
            <span>{mapButtonText}</span>
          </a>
        </div>
      )}
    </div>
  );
}

export default LocationBlock; 